import Vue from 'vue';

// #region : Dialogs :
/**
 * Sets the value of createSystemDialog
 * @param {*} state
 * @param {*} val
 */
const setCreateSystemDialog = (state, showDialog) => {
  state.createSystemDialog = showDialog;
};
/**
 * Sets the value of createSubsystemDialog
 * @param {*} state
 * @param {*} val
 */
const setCreateSubsystemDialog = (state, showDialog) => {
  state.createSubsystemDialog = showDialog;
};
/**
 * Shows new project dialog
 * @param {*} state
 * @param {*} showDialog
 */
const showCreateNewProjectDialog = (state, showDialog) => {
  state.showCreateNewProjectDialog = showDialog;
};
// #endregion

// #region : Loading/Saving Flags :
/**
 * Sets accessoryLoading in state
 * @param {*} state
 * @param {*} loading
 */
const setAccessoryLoading = (state, loading) => {
  state.accessoryLoading = loading;
};
/**
 * Sets productLoading in state
 * @param {*} state
 * @param {*} loading
 */
const setProductLoading = (state, loading) => {
  state.productLoading = loading;
};
/**
 * Sets availableSubsystemsLoading in state
 * @param {*} state
 * @param {*} loading
 */
const setAvailableSubsystemsLoading = (state, loading) => {
  state.availableSubsystemsLoading = loading;
};
/**
 * Sets savingNewSystemFlag
 * @param {*} state
 * @param {*} isSaving
 */
const setSavingNewSystem = (state, isSaving) => {
  state.savingNewSystem = isSaving;
};
/**
 * Sets the value of `savingNewProject` in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isSaving - The new value for `savingNewProject`.
 */
const setSavingNewProject = (state, isSaving) => {
  state.savingNewProject = isSaving;
};
/**
 * Sets savingNewSubsystem flag
 * @param {*} state
 * @param {*} isSaving
 */
const setSavingNewSubsystem = (state, isSaving) => {
  state.savingNewSubsystem = isSaving;
};
/**
 * Sets componentsLoading in state
 * @param {*} state
 * @param {*} loading
 */
const setComponentsLoading = (state, loading) => {
  state.componentsLoading = loading;
};
/**
 * Sets loading flag for project List
 * @param {*} state
 * @param {*} isLoading
 */
const setProjectsLoading = (state, isLoading) => {
  state.projectsLoading = isLoading;
};
/**
 * Sets loading flag for systems list
 * @param {*} state
 * @param {*} isLoading
 */
const setSystemsLoading = (state, isLoading) => {
  state.systemsLoading = isLoading;
};
/**
 * Sets loading flag for subsystems list
 * @param {*} state
 * @param {*} isLoading
 */
const setSubsystemsLoading = (state, isLoading) => {
  state.subsystemsLoading = isLoading;
};
/**
 * Sets loading flag for currentProject
 * @param {*} state
 * @param {*} isLoading
 */
const setCurrentProjectLoading = (state, isLoading) => {
  state.currentProjectLoading = isLoading;
};
/**
 * Sets loading flag for currentSystem
 * @param {*} state
 * @param {*} isLoading
 */
const setCurrentSystemLoading = (state, isLoading) => {
  state.currentSystemLoading = isLoading;
};
/**
 * Sets loading flag for currentSubsystem
 * @param {*} state
 * @param {*} isLoading
 */
const setCurrentSubsystemLoading = (state, isLoading) => {
  state.currentSubsystemLoading = isLoading;
};
/**
 * Sets the value of isValidatingComponent in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isValidating - The new value for isValidatingComponent.
 */
const setIsValidatingComponent = (state, isValidating) => {
  state.isValidatingComponent = isValidating;
};
/**
 * Sets the value of isRefreshingTreeSummaryData in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isRefreshing - The new value for isRefreshingTreeSummaryData.
 */
const setIsRefreshingTreeSummaryData = (state, isRefreshing) => {
  state.isRefreshingTreeSummaryData = isRefreshing;
};

/**
 * Sets the value of isLoadingSubsystemSteps in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isLoading - The new value for isLoadingSubsystemSteps.
 */
const setIsLoadingSubsystemSteps = (state, isLoading) => {
  state.isLoadingSubsystemSteps = isLoading;
};
/**
 * Sets the isLoadingStepComponent value in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isLoading - The new value for isLoadingStepComponent.
 */
const setIsLoadingStepComponent = (state, isLoading) => {
  state.isLoadingStepComponent = isLoading;
};
/**
 * Sets the isLoadingSubsystem value in the state.
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isLoading - The new value for isLoadingSubsystem.
 */
const setIsLoadingSubsystem = (state, isLoading) => {
  state.isLoadingSubsystem = isLoading;
};
/**
 * Sets the loading state of the system.
 *
 * @param {Object} state - The Vuex state object.
 * @param {boolean} isLoading - The loading state to set.
 */
const setIsLoadingSystem = (state, isLoading) => {
  state.isLoadingSystem = isLoading;
};

// #endregion

// #region : Hydrate Entities :
/**
 * Hydrates the currentProject state with input object
 * @param {*} response
 */
const hydrateCurrentProject = (state, responseProject) => {
  state.currentProject = responseProject;
  state.currentProjectLoading = false;
};
/**
 * Updates state with a list of available systems
 * @param {*} state
 */
const hydrateAvailableSystemDefinitions = (state, systems) => {
  state.availableSystemDefinitions = [];
  systems.forEach((x) => {
    state.availableSystemDefinitions.push({
      id: x.id,
      systemDefinitionId: x.systemDefinitionId,
      projectId: x.projectId,
      name: x.name,
      description: x.description,
      systemType: x.systemType,
      sellPrice: x.sellPrice,
      percentComplete: x.percentComplete,
      subsystemModels: x.subsystemModels
    });
  });
};
/**
 * Updates state with a list of available systems
 * @param {*} state
 */
const hydrateAvailableSubsystemDefinitions = (state, subsystems) => {
  state.availableSubsystemDefinitions = [];
  subsystems.forEach((x) => {
    state.availableSubsystemDefinitions.push({
      id: x.id,
      subsystemDefinitionId: x.subsystemDefinitionId,
      systemDefinitionId: x.systemDefinitionId,
      name: x.name,
      description: x.description,
      subsystemType: x.subsystemType,
      sellPrice: x.sellPrice,
      percentComplete: x.percentComplete
    });
  });
};
/**
 * Hydrates the currentSystem with input object
 * @param {} state
 * @param {*} newSystem
 */
const hydrateCurrentSystem = (state, newSystem) => {
  state.currentSystem = newSystem;
  state.currentSystemLoading = false;
};
/**
 * Hydrates the currentSubsystem with input object
 * @param {*} state
 * @param {*} newSubsystem
 */
const hydrateCurrentSubsystem = (state, newSubsystem) => {
  state.currentSubsystem = newSubsystem;
};
/**
 * Hydrates the steps in steate
 * @param {*} state
 * @param {*} steps
 */
const hydrateSubsystemSteps = (state, steps) => {
  // console.log('hydrating steps:' + JSON.stringify(steps));
  state.currentSubsystemSteps = steps;
};
/**
 * Updates the sigmessage for the current subsystem step component
 * @param {*} state
 * @param {*} message
 */
const updateCurrentStepComponentSigMessages = (state, message) => {
  state.currentSubsystemStepComponent.sigMessageModel.message = message;
};
/**
 * Hydrates currentSubsystemComponents
 * @param {*} state
 * @param {*} components
 */
const hydrateStepComponent = (state, component) => {
  // convert setting value to boolean if needed
  component.componentSettingModels.forEach((x) => {
    if (x.value == 'true' || x.value == 'false') {
      x.value = x.value == 'true';
    }
  });
  state.currentSubsystemStepComponent = component;
};
/**
 * Hydrates the projects array with input project list
 * @param {*} state
 * @param {*} responseProjects
 */
const hydrateProjects = (state, responseProjects) => {
  state.projects = responseProjects;
};
/**
 * Hydrates the project setting definitions in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {Array} projectSettingDefinitions - The project setting definitions to be hydrated.
 */
const hydrateProjectSettingDefinitions = (state, projectSettingDefinitions) => {
  state.projectSettingDefinitions = projectSettingDefinitions;
};
/**
 * Hydrates the systems array with input records
 * @param {*} state
 * @param {*} records
 */
const hydrateSystems = (state, records) => {
  state.systems = records;
};
/**
 * Hydrates the systems array with input records
 * @param {*} state
 * @param {*} records
 */
const hydrateSubsystems = (state, payload) => {
  Vue.set(state.subsystems, `subsystem_${payload.systemId}`, payload.records);
};
// #endregion

// #region : Reset Entities :
/**
 * resets currentProject
 * @param {*} state
 */
const resetCurrentProject = (state) => {
  state.currentProject = null;
};
/**
 * resets currentSystem
 * @param {*} state
 */
const resetCurrentSystem = (state) => {
  state.currentSystem = null;
};
/**
 * resets currentSubsystem
 * @param {*} state
 */
const resetCurrentSubsystem = (state, resetSteps) => {
  if (resetSteps) state.currentSubsystemStep = null;

  state.currentSubsystem = null;
};
/**
 * Resets CurrentSubsystemStepComponent
 * @param {*} state
 */
const resetCurrentSubsystemStepComponent = (state) => {
  state.currentSubsystemStepComponent = null;
};
/**
 * Resets currentSubsystemStep
 * @param {*} state
 */
const resetCurrentSubsystemStep = (state) => {
  state.currentSubsystemStep = null;
};
/**
 * Resets currentSubsystemSteps
 *
 * @param {*} state
 */
const resetCurrentSubsystemSteps = (state) => {
  // console.log('resetting currentSubsystemSteps');
  state.currentSubsystemSteps = [];
};
// #endregion

// #region : Actions :
/**
 * Sets the product sort by value in the state.
 * @param {Object} state - The Vuex state object.
 * @param {string} sortBy - The value to set the product sort by to.
 * @returns {void}
 */
const setProductSortBy = (state, sortBy) => {
  state.productSortBy = sortBy;
};
/**
 * Sets the requested step index in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {number} index - The index of the requested step.
 */
const setRequestedStepIndex = (state, index) => {
  state.requestedStepIndex = index;
};
/**
 * Increments the subsystem key
 * @param {*} param0
 */
const incrementSubsystemKey = (state) => {
  state.subsystemKey++;
};
/**
 * updates selected product for currentComponent
 * @param {*} state
 * @param {*} val
 */
const selectProduct = (state, { productId: productId, selected: selected }) => {
  // console.log('selectProduct: start');
  // update selected flag
  state.currentSubsystemStepComponent.productModels.forEach((item) => {
    // decrease totals if a product is deselected
    if ((selected && item.selected && item.id != productId) || (!selected && item.selected && item.id == productId)) {
      state.currentSubsystem.sellPrice -= item.sellPrice;
      state.currentSystem.sellPrice -= item.sellPrice;
      state.currentProject.sellPrice -= item.sellPrice;
    } else if (selected && !item.selected && item.id === productId) {
      state.currentSubsystem.sellPrice += item.sellPrice;
      state.currentSystem.sellPrice += item.sellPrice;
      state.currentProject.sellPrice += item.sellPrice;
    }
    // increase totals if a product is selected
    if (item.id === productId) item.selected = selected;
  });
  // console.log('selectProduct: end');
};
/**
 * Updates the quantity of an accessory and adjusts the sell prices accordingly.
 *
 * @param {Object} state - The current state object.
 * @param {number} quantity - The quantity to be added or subtracted.
 */
const updateAccessoryQuantity = (state, payload) => {
  const currentProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.id === payload.productId);
  if (currentProduct) {
    const currentAccessory = currentProduct.productAccessoryModels.find((x) => x.id === payload.accessoryId);
    if (currentAccessory) {
      const netQuantityChange = payload.quantity - currentAccessory.quantity;
      const netChange = currentAccessory.sellPrice * netQuantityChange;
      state.currentSubsystem.sellPrice += netChange;
      state.currentSystem.sellPrice += netChange;
      state.currentProject.sellPrice += netChange;
      currentAccessory.quantity = payload.quantity;
    }
  }
};
/**
 * updates selected accessory for currentComponent
 * @param {*} state
 * @param {*} accessoryId
 */
const selectAccessory = (state, payload) => {
  const currentProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.id === payload.productId);
  if (currentProduct) {
    const currentAccessory = currentProduct.productAccessoryModels.find((x) => x.id === payload.accessoryId);
    if (currentAccessory) {
      currentAccessory.selected = payload.selected;
      if (payload.selected) {
        // default qty  based on parent
        if (currentAccessory.defaultToParentQuantity) {
          currentAccessory.quantity = currentProduct.quantity * currentAccessory.minQuantity;
        }
        // allow business logic to override parent default qty
        if (
          currentAccessory.minQuantity === 1 &&
          currentAccessory.maxQuantity === 1 &&
          (!currentAccessory.value || currentAccessory.value === 0)
        ) {
          currentAccessory.quantity = 1 * currentProduct.quantity;
        } else if (!currentAccessory.quantity || currentAccessory.quantity === 0) {
          currentAccessory.quantity = currentAccessory.minQuantity * currentProduct.quantity;
        }
        // only update price if accessory is configured and has a valid price
        const netPriceChange = currentAccessory.sellPrice * currentAccessory.quantity;
        state.currentSubsystem.sellPrice += netPriceChange;
        state.currentSystem.sellPrice += netPriceChange;
        state.currentProject.sellPrice += netPriceChange;
      } else {
        const netPriceChange = currentAccessory.sellPrice * payload.quantity;
        state.currentSubsystem.sellPrice -= netPriceChange;
        state.currentSystem.sellPrice -= netPriceChange;
        state.currentProject.sellPrice -= netPriceChange;
      }
    }
  }
};
/**
 * Updates the project settings
 * @param {*} state
 * @param {*} payload
 */
const updateProjectSettingModel = (state, payload) => {
  try {
    let projectSettingModelToUpdate = state.currentProject.projectSettingModels.find(
      (x) => x.projectSettingDefinitionId === payload.updatedProjectSettingModel.projectSettingDefinitionId
    );
    if (!projectSettingModelToUpdate)
      throw (
        'Could not find projectSettingModel: currentProject.projectSettingDefinitionId = ' +
        payload.updatedProjectSettingModel.projectSettingDefinitionId
      );

    projectSettingModelToUpdate.value = payload.newValue;
  } catch (ex) {
    console.log(ex.toString());
    this.commit(
      'app/showToast',
      {
        color: 'error',
        message: 'Error saving selection, please try again', // user friendly error
        timeout: 5000
      },
      { root: true }
    );
  }
};
/**
 * Updates a componentSettingModel instance on currentSubsystem
 * @param {*} param0
 */
const updateComponentSettingModel = (state, payload) => {
  try {
    const componentToUpdate = state.currentSubsystemStepComponent;
    if (!componentToUpdate) throw 'Could not find Component: currentSubsystem[' + payload.componentIndex + ']';

    let componentSettingModelToUpdate = componentToUpdate.componentSettingModels.find(
      (x) => x.componentSettingDefinitionId === payload.updatedComponentSettingModel.componentSettingDefinitionId
    );
    if (!componentSettingModelToUpdate)
      throw (
        'Could not find componentSettingModel: currentSubsystem[' +
        payload.componentIndex +
        '].componentSettingDefinitionId = ' +
        payload.updatedComponentSettingModel.componentSettingDefinitionId
      );

    componentSettingModelToUpdate.value = payload.newValue;
  } catch (ex) {
    console.log(ex.toString());
    this.commit(
      'app/showToast',
      {
        color: 'error',
        message: 'Error saving selection, please try again', // user friendly error
        timeout: 5000
      },
      { root: true }
    );
  }
};
/**
 * Updates quantity of input product
 * @param {*} state
 * @param {*} quantity
 */
const updateProductQuantity = (state, payload) => {
  if (!payload.quantity || isNaN(payload.quantity)) return;

  const currentProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.id === payload.productId);
  if (currentProduct) {
    const netQuantityChange = payload.quantity - currentProduct.quantity;
    const netPriceChange = currentProduct.sellPrice * netQuantityChange;
    state.currentSubsystem.sellPrice += netPriceChange;
    state.currentSystem.sellPrice += netPriceChange;
    state.currentProject.sellPrice += netPriceChange;

    currentProduct.quantity = parseInt(payload.quantity);
  }
};
/**
 * Inserts a duplicated accessory
 * @param {*} state
 * @param {*} payload   { newAccessory, index}
 */
const addAccessory = (state, payload) => {
  if (payload.index == null || !payload.newAccessory) return;

  const currentProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.selected);
  if (currentProduct) {
    currentProduct.productAccessoryModels.splice(payload.index + 1, 0, payload.newAccessory);
  }
};
/**
 * Deletes a duplicate accessory
 * @param {*} state
 * @param {*} payload
 */
const deleteAccessory = (state, index) => {
  if (!index || index == 0) return;

  const currentProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.selected);
  if (currentProduct) {
    // double check that this is a deletable accessory
    const accessoryToDelete = currentProduct.productAccessoryModels[index];
    const previousAccessory = currentProduct.productAccessoryModels[index - 1];
    if (accessoryToDelete.productId == previousAccessory.productId) {
      currentProduct.productAccessoryModels.splice(index, 1);
    }
  }
};
/**
 * Updates a given component
 * @param {*} state
 * @param {*} component
 */
const updateComponent = (state, component) => {
  state.currentSubsystemStepComponent = component;

  // update price totals from payload
  /*state.currentProject.sellPrice = payload.sellPrice;
  state.currentSystem.sellPrice = updatedSystem.sellPrice;
  state.currentSubsystem.sellPrice = updatedSubsystem.sellPrice;*/
};
/**
 * Refreshes state with price and status
 * @param {*} state
 * @param {*} summaryData
 */
const refreshTreeSummaryData = (state, summaryData) => {
  state.currentProject.sellPrice = summaryData.sellPrice;
  state.currentProject.percentComplete = summaryData.percentComplete;
  // get system updates
  if (summaryData.systemModels && summaryData.systemModels.length > 0) {
    summaryData.systemModels.forEach((currentSystemModel) => {
      if (!state.currentSystem) return;
      state.currentSystem.sellPrice = currentSystemModel.sellPrice;
      state.currentSystem.percentComplete = currentSystemModel.percentComplete;
      // get subsystem updates
      if (currentSystemModel.subsystemModels && currentSystemModel.subsystemModels.length > 0) {
        const matchingSubsystem = currentSystemModel.subsystemModels.find((x) => x.id === state.currentSubsystem.id);
        if (matchingSubsystem) {
          state.currentSubsystem.sellPrice = matchingSubsystem.sellPrice;
          state.currentSubsystem.percentComplete = matchingSubsystem.percentComplete;
        }
      }
    });
  }
};
/**
 * Updates specific accessory properties
 * @param {*} state
 * @param {*} payload
 */
const refreshAccessory = (state, payload) => {
  const selectedProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.selected);
  if (selectedProduct) {
    if (payload.originalAccessory) {
      // decrement sellPrice for old configured accessory before adding new pricing
      const netPriceChange = payload.originalAccessory.sellPrice * payload.originalAccessory.quantity;
      state.currentSubsystem.sellPrice -= netPriceChange;
      state.currentSystem.sellPrice -= netPriceChange;
      state.currentProject.sellPrice -= netPriceChange;
    }

    Vue.set(selectedProduct.productAccessoryModels, payload.index, payload.updatedAccessory);
    // update prices if necessary
    const currentAccessory = selectedProduct.productAccessoryModels[payload.index];
    const netPriceChange = currentAccessory.sellPrice * currentAccessory.quantity;
    state.currentSubsystem.sellPrice += netPriceChange;
    state.currentSystem.sellPrice += netPriceChange;
    state.currentProject.sellPrice += netPriceChange;
  }
};
/**
 * Updates specific product properties
 * @param {*} state
 * @param {*} payload
 */
const refreshProduct = (state, payload) => {
  const selectedProductIndex = state.currentSubsystemStepComponent.productModels.findIndex((x) => x.selected);
  const currentProduct = state.currentSubsystemStepComponent.productModels.find((x) => x.selected);
  const originalPrice = currentProduct.sellPrice * currentProduct.quantity;

  // update prices if necessary
  // check for empty subsystem/system/project price
  if (!state.currentSubsystem.sellPrice) state.currentSubsystem.sellPrice = originalPrice;
  if (!state.currentSystem.sellPrice) state.currentSystem.sellPrice = originalPrice;
  if (!state.currentProject.sellPrice) state.currentProject.sellPrice = originalPrice;

  const netPriceChange = payload.updatedProduct.sellPrice * payload.updatedProduct.quantity - originalPrice;
  state.currentSubsystem.sellPrice += netPriceChange;
  state.currentSystem.sellPrice += netPriceChange;
  state.currentProject.sellPrice += netPriceChange;

  Vue.set(state.currentSubsystemStepComponent.productModels, selectedProductIndex, payload.updatedProduct);
};
// #endregion

// #region : Hints :
/**
 * Sets Subsystem Hint Visibility
 * @param {*} state
 * @param {*} show
 */
const setSubsystemHintVisibility = (state, show) => {
  if (
    state.currentSubsystem &&
    state.currentSubsystemStepComponent &&
    state.currentSubsystemStepComponent.sigMessageModels &&
    state.currentSubsystemStepComponent.sigMessageModels.length > 0
  ) {
    state.currentSubsystemStepComponent.sigMessageModels.forEach((x) => {
      if (x.messageType.toLowerCase() === 'sig') {
        x.hide = !show;
      }
    });
  }
};
// #endregion

export default {
  hydrateAvailableSystemDefinitions,
  setAvailableSubsystemsLoading,
  hydrateAvailableSubsystemDefinitions,
  updateCurrentStepComponentSigMessages,
  hydrateCurrentProject,
  hydrateCurrentSystem,
  hydrateCurrentSubsystem,
  setAccessoryLoading,
  setProductLoading,
  hydrateProjects,
  hydrateProjectSettingDefinitions,
  setProductSortBy,
  setProjectsLoading,
  setSystemsLoading,
  setSubsystemsLoading,
  setCurrentProjectLoading,
  setCurrentSystemLoading,
  setCurrentSubsystemLoading,
  setIsValidatingComponent,
  setIsRefreshingTreeSummaryData,
  setIsLoadingSubsystemSteps,
  setIsLoadingStepComponent,
  setIsLoadingSubsystem,
  setIsLoadingSystem,
  resetCurrentProject,
  resetCurrentSystem,
  resetCurrentSubsystem,
  resetCurrentSubsystemStepComponent,
  resetCurrentSubsystemStep,
  resetCurrentSubsystemSteps,
  showCreateNewProjectDialog,
  incrementSubsystemKey,
  updateProjectSettingModel,
  updateComponentSettingModel,
  setSavingNewSystem,
  setCreateSystemDialog,
  setCreateSubsystemDialog,
  setSubsystemHintVisibility,
  selectProduct,
  refreshProduct,
  updateComponent,
  updateAccessoryQuantity,
  updateProductQuantity,
  selectAccessory,
  hydrateSystems,
  hydrateSubsystems,
  hydrateSubsystemSteps,
  setComponentsLoading,
  hydrateStepComponent,
  refreshTreeSummaryData,
  setSavingNewSubsystem,
  setSavingNewProject,
  refreshAccessory,
  addAccessory,
  deleteAccessory,
  setRequestedStepIndex
};
